import { makePixStatusRepository } from 'modules/customer/infra/repositories';

import { CheckPixStatusUseCase } from './implementations/CheckPixStatusUseCase';

let instance: CheckPixStatusUseCase | null = null;

export default function makeCheckPixStatusUseCase() {
  if (!instance) {
    const repository = makePixStatusRepository();

    instance = new CheckPixStatusUseCase(repository);
  }

  return instance;
}
